// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"25095302","170":"800251cd","401":"50348fae","551":"7f6d21be","956":"c12ffbfa"}[chunkId] + ".chunk.js";
};